// extracted by mini-css-extract-plugin
export default {"container":"DSIPackages_container__V7wVB","list":"DSIPackages_list__q9wJM"};